import React from 'react';
import { Select } from 'antd';
import classNames from 'classnames';
const { Option, OptGroup } = Select;
import { ISelectOption } from './DefaultSelectOption';
import ABSField from '../../ABSField';
import { IABSSelectViewProps } from '../interface';
import emitter, { EventName } from '../../../utils/eventUtils';
import './index.less';

export class ABSSelectView extends React.Component<IABSSelectViewProps, any> {
  public static defaultProps = {
    size: 'default',
    filterOption: true
  };

  select;

  componentDidMount() {
    emitter.addListener(EventName.hideDropDown, this.handleScroll);
  }

  componentWillUnmount() {
    emitter.removeListener(EventName.hideDropDown, this.handleScroll);
  }

  handleScroll = () => {
    if (this.select) {
      this.select.rcSelect.setOpenState(false);
      // this.select.blur();
    }
  }

  renderSingle(item: ISelectOption, index: number) {
    const { value, title, disabled, labelName } = item;
    if (!value && !labelName) {
      return null;
    }

    return (
      <Option key={`${value}${index}`} title={title} value={value} disabled={disabled}>
        {labelName}
      </Option>
    );
  }

  renderOptions(optionDatas: ISelectOption[]) {
    return optionDatas.map((item, index) => {
      const { children, labelName } = item;
      if (children && children.length >= 0) {
        return <OptGroup label={labelName}>{children.map((values, indexs) => this.renderSingle(values, indexs))}</OptGroup>;
      }
      return this.renderSingle(item, index);
    });
  }

  IsShowOptionData() {
    const {
      size,
      placeholder,
      className,
      disabled,
      // onSelect,
      onSearch,
      // onFocus,
      // onBlur,
      dropdownMatchSelectWidth,
      dropdownClassName,
      selectOptions,
      defaultValue,
      mode,
      notFoundContent,
      showSearch,
      value,
      onChange,
      titleClassName,
      filterOption,
      style,
      suffixIcon,
      labelInValue,
      onDeselect,
      optionLabelProp
    } = this.props;

    // const selectStyles = commonUtils.isNullOrUndefined(value) || !value.length // (value === undefined || value === null || !value.length)
    //   ? 'select-field-placeholder'
    //   : 'select-field-placeholder-disabled';
    const selectClasses = classNames(
      'abs-select',
      `abs-select-size-${size}`,
      // selectStyles,
      className
    );
    const dropdownClasses = classNames({ 'abs-select-dropdown': mode }, dropdownClassName);
    const optionFilterProp = showSearch ? { optionFilterProp: 'children' } : {};
    const {
      title,
      required,
      removePaddingLeft,
      removeMarginBottom,
      labelWidth,
      result,
      desc,
      isVertical,
      contentWidth,
      customOptions,
      isFlex
    } = this.props;
    return (
      <ABSField
        result={result}
        className={selectClasses}
        title={title}
        required={required}
        labelWidth={labelWidth}
        removePaddingLeft={removePaddingLeft}
        removeMarginBottom={removeMarginBottom}
        desc={desc}
        titleClassName={titleClassName}
        isVertical={isVertical}
        contentWidth={contentWidth}
      >
        <Select
          labelInValue={labelInValue}
          defaultValue={defaultValue}
          value={value}
          size={size}
          placeholder={placeholder}
          disabled={disabled}
          onChange={onChange}
          dropdownMatchSelectWidth={dropdownMatchSelectWidth}
          mode={mode}
          ref={view => { this.select = view; }}
          notFoundContent={notFoundContent !== undefined ? notFoundContent : '无数据'}
          dropdownClassName={dropdownClasses}
          showSearch={showSearch}
          filterOption={filterOption}
          onSearch={onSearch}
          style={style}
          suffixIcon={suffixIcon}
          onDeselect={onDeselect}
          {...optionFilterProp}
          optionLabelProp={optionLabelProp}
          getPopupContainer={isFlex ? (triggerNode: any) => triggerNode.parentNode : undefined}
        >
          {customOptions || this.renderOptions(selectOptions || [])}
        </Select>
      </ABSField>
    );
  }

  render() {
    return this.IsShowOptionData();
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSelect/ABSSelectView/index.tsx